import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import { DinamicTitle } from '../utils/DinamicTitle';

export default function ListUsers() {
  DinamicTitle('List Users || Komaladewi');
  const [users, setUsers] = useState([]);
  const [cabangList, setCabangList] = useState([]);
  const [filterRole, setFilterRole] = useState('Semua');
  const [filterStatus, setFilterStatus] = useState('Semua');
  const [loading, setLoading] = useState(false);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    password: '',
    password_confirmation: '',
    role: 'kasir',
    cabang_id: ''
  });
  
  const navigate = useNavigate();

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await http.get('/users', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setUsers(res.data.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchCabang = async () => {
    try {
      const res = await http.get('/cabang', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setCabangList(res.data.data || res.data); // Adjust depending on response structure
    } catch (err) {
      console.error('Failed to fetch cabang', err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchCabang();
  }, [navigate]);

  const filteredUsers = users.filter(user => {
    const matchRole = filterRole === 'Semua' || user.role.includes(filterRole);
    const matchStatus = filterStatus === 'Semua' || (filterStatus === 'Aktif' ? user.is_active : !user.is_active);
    return matchRole && matchStatus;
  });

  const toggleStatus = async (userId) => {
    try {
      setLoading(true);
      await http.patch(`/users/${userId}/status`, {}, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      // Real-time reload data
      await fetchUsers();
    } catch (err) {
      console.error(err);
      setLoading(false); // only set to false on error, as fetchUsers handles it on success
    }
  };

  const handleForceLogout = async () => {
    if (!selectedUser) return;
    try {
      setLoading(true);
      const res = await http.post(`/users/${selectedUser.id}/force-logout`, {}, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      // Optionally add a toast here
      await fetchUsers();
      setIsLogoutModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('Gagal force logout pengguna.');
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      await http.post('/users', formData, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      await fetchUsers();
      setIsAddModalOpen(false);
      setFormData({
        name: '', username: '', email: '', password: '', password_confirmation: '', role: 'kasir', cabang_id: ''
      });
      // you could add a toast here if imported
      alert('Berhasil membuat user baru!');
    } catch (err) {
      console.error(err);
      const responseData = err.response?.data;
      
      let errorMsg = 'Gagal membuat user baru, pastikan data yang dimasukkan benar.';
      
      if (responseData?.errors) {
        // Gabungkan semua pesan error validasi menjadi satu string
        const validationErrors = Object.values(responseData.errors).flat().join('\n');
        errorMsg = `Data tidak valid:\n${validationErrors}`;
      } else if (responseData?.message) {
        errorMsg = responseData.message;
      } else if (typeof responseData === 'string') {
        errorMsg = responseData;
      }
      
      alert(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Layouts
    // title={'List Users'}
    >
      <div className="container mx-auto  px-4 sm:px-8">
        <div className="py-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center -mx-4 sm:-mx-8 px-4 sm:px-8 mb-4 gap-4">
            <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Daftar Pengguna</h2>
            <div className="flex flex-col sm:flex-row gap-3 items-center w-full md:w-auto">
              <button 
                onClick={() => setIsAddModalOpen(true)}
                className="w-full sm:w-auto px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-md text-sm font-semibold shadow flex items-center justify-center gap-2"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Tambah Pengguna
              </button>
              <select
                value={filterRole}
                onChange={(e) => setFilterRole(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              >
                <option value="Semua">Semua Role</option>
                <option value="kasir">Kasir</option>
                <option value="operator">Operator</option>
                <option value="admin">Admin</option>
              </select>
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              >
                <option value="Semua">Semua Status</option>
                <option value="Aktif">Aktif</option>
                <option value="Non-Aktif">Non-Aktif</option>
              </select>
            </div>
          </div>
          <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
              {loading ? (
                <>
                  <div className="flex  items-center justify-center">
                    <div className="w-5 h-5  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                    <div className=" font-semibold px-2 py-1 rounded-br-md rounded-bl-md">Memuat data....</div>
                  </div>
                </>
              ) : (
                <>
                  <table className="min-w-full leading-normal">
                    <thead>
                      <tr>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Nomor
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Nama
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Username
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Email
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Role
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          Status Akun
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          Sesi (Online)
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">
                          Aksi
                        </th>
                        <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100" />
                      </tr>
                    </thead>

                    <tbody>
                      {filteredUsers.map((user, i) => (
                        <tr key={user.id} className="hover:bg-slate-200 bg-white">
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            <div className="ml-3">
                              <p className="text-gray-900 whitespace-no-wrap">{i + 1}</p>
                            </div>
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            <p className="text-gray-900 whitespace-no-wrap">{user.name}</p>
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            <p className="text-gray-900 whitespace-no-wrap">{user.username}</p>
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            <p className="text-gray-900 whitespace-no-wrap">{user.email}</p>
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            <span className={`relative inline-block px-3 py-1 font-semibold leading-tight ${user.role.includes('kasir') ? 'text-green-900' : user.role.includes('operator') ? 'text-blue-900' : 'text-purple-900'}`}>
                              <span aria-hidden className={`absolute inset-0 opacity-50 rounded-full ${user.role.includes('kasir') ? 'bg-green-200' : user.role.includes('operator') ? 'bg-blue-200' : 'bg-purple-200'}`} />
                              <span className="relative">{user.role}</span>
                            </span>
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            {user.is_active ? (
                              <span className="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                                <span aria-hidden className="absolute inset-0 bg-green-200 opacity-50 rounded-full" />
                                <span className="relative">Aktif</span>
                              </span>
                            ) : (
                              <span className="relative inline-block px-3 py-1 font-semibold text-red-900 leading-tight">
                                <span aria-hidden className="absolute inset-0 bg-red-200 opacity-50 rounded-full" />
                                <span className="relative">Non-Aktif</span>
                              </span>
                            )}
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm">
                            {user.is_login ? (
                              <span className="relative inline-block px-3 py-1 font-semibold text-emerald-900 leading-tight">
                                <span aria-hidden className="absolute inset-0 bg-emerald-200 opacity-50 rounded-full" />
                                <span className="relative flex items-center gap-1">
                                  <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                                  Online
                                </span>
                              </span>
                            ) : (
                              <span className="relative inline-block px-3 py-1 font-semibold text-gray-900 leading-tight">
                                <span aria-hidden className="absolute inset-0 bg-gray-200 opacity-50 rounded-full" />
                                <span className="relative">Offline</span>
                              </span>
                            )}
                          </td>
                          <td className="px-5 py-1 border-b border-gray-200 text-sm text-right space-x-2">
                            <button 
                              onClick={() => { setSelectedUser(user); setIsModalOpen(true); }}
                              type="button" 
                              title={user.is_active ? "Non-Aktifkan User" : "Aktifkan User"}
                              className={`inline-block px-3 py-1 rounded text-white text-xs font-bold ${user.is_active ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}
                            >
                              {user.is_active ? "Non-Aktifkan" : "Aktifkan"}
                            </button>
                            <button 
                              onClick={() => { setSelectedUser(user); setIsLogoutModalOpen(true); }}
                              disabled={!user.is_login}
                              type="button" 
                              title="Force Logout User"
                              className={`inline-block px-3 py-1 rounded text-white text-xs font-bold ml-2 ${!user.is_login ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                            >
                              Logout
                            </button>
                            <button type="button" className="inline-block text-gray-500 hover:text-gray-700 ml-2">
                              <svg className="inline-block h-6 w-6 fill-current" viewBox="0 0 24 24">
                                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {isModalOpen && selectedUser && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/* Background overlay */}
            <div className="fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity" aria-hidden="true" onClick={() => setIsModalOpen(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10 ${selectedUser.is_active ? 'bg-red-100' : 'bg-green-100'}`}>
                    <svg className={`h-6 w-6 ${selectedUser.is_active ? 'text-red-600' : 'text-green-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                      Konfirmasi Perubahan Status
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Apakah Anda yakin ingin <strong>{selectedUser.is_active ? 'menonaktifkan' : 'mengaktifkan'}</strong> pengguna dengan nama <strong>{selectedUser.name}</strong>?
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm transition-colors ${selectedUser.is_active ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500' : 'bg-green-600 hover:bg-green-700 focus:ring-green-500'}`}
                  onClick={() => { toggleStatus(selectedUser.id); setIsModalOpen(false); }}
                >
                  Ya, {selectedUser.is_active ? 'Non-Aktifkan' : 'Aktifkan'}
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
                  onClick={() => setIsModalOpen(false)}
                >
                  Batal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Force Logout Confirmation Modal */}
      {isLogoutModalOpen && selectedUser && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" aria-hidden="true" onClick={() => setIsLogoutModalOpen(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="sm:flex sm:items-start">
                <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                  <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                    Force Logout Pengguna
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Yakin ingin memaksa keluar (force logout) <strong>{selectedUser.name}</strong>? Pengguna akan segera dikeluarkan dari sistem dan token aksesnya akan hangus.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button 
                  type="button" 
                  className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={handleForceLogout}
                  disabled={loading}
                >
                  {loading ? 'Memproses...' : 'Ya, Logout Sekarang'}
                </button>
                <button 
                  type="button" 
                  className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 sm:mt-0 sm:w-auto sm:text-sm"
                  onClick={() => setIsLogoutModalOpen(false)}
                >
                  Batal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add User Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="add-modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity" aria-hidden="true" onClick={() => setIsAddModalOpen(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
              <form onSubmit={handleAddUser}>
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                      <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" id="add-modal-title">
                        Tambah Pengguna Baru
                      </h3>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Nama Lengkap</label>
                          <input type="text" name="name" required value={formData.name} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border" />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Username</label>
                          <input type="text" name="username" required minLength={5} value={formData.username} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border" />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700">Email</label>
                          <input type="email" name="email" required value={formData.email} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border" />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Password</label>
                            <input type="password" name="password" required minLength={8} value={formData.password} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border" />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Konfirmasi Password</label>
                            <input type="password" name="password_confirmation" required minLength={8} value={formData.password_confirmation} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border" />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Role</label>
                            <select name="role" required value={formData.role} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border">
                              <option value="kasir">Kasir</option>
                              <option value="operator">Operator</option>
                            </select>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Pilih Cabang</label>
                            <select name="cabang_id" required value={formData.cabang_id} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 sm:text-sm px-3 py-2 border">
                              <option value="">-- Pilih Cabang --</option>
                              {Array.isArray(cabangList) && cabangList
                                .filter(cabang => cabang.nama_cabang && !cabang.nama_cabang.toLowerCase().includes('brankas'))
                                .map(cabang => (
                                <option key={cabang.id} value={cabang.id}>{cabang.nama_cabang}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm transition-colors ${isSubmitting ? 'bg-amber-400 cursor-not-allowed' : 'bg-amber-600 hover:bg-amber-700 focus:ring-amber-500'}`}
                  >
                    {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    Batal
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Layouts>
  );
}
